import { render, staticRenderFns } from "./SystemInput.vue?vue&type=template&id=787127f2&scoped=true&"
import script from "./SystemInput.vue?vue&type=script&lang=js&"
export * from "./SystemInput.vue?vue&type=script&lang=js&"
import style0 from "./SystemInput.vue?vue&type=style&index=0&id=787127f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787127f2",
  null
  
)

export default component.exports